if (typeof document !== 'undefined') {
  var baseOrigin = location.origin;
}

/*
 * Handles script loading to resources that needs authentication.
 * The logic should be: If the request is a cors request and if SystemJS has been configured to use crossorigin
 * Then that should ripple through the rest of the resource fetching except if the location of the resource being 
 * fetched is different from where SystemJS access-control config. In that case we should assume that it's an anonymous
 * location.
 */
(function (global) {
  var QlikSystem = global.QlikSystem;
  var systemJSPrototype = QlikSystem.constructor.prototype;

  systemJSPrototype.createScript = function (url) {
    var script = document.createElement('script');
    script.async = true;
    script.initiator = 'SystemJS';
    // Only add cross origin for actual cross origin
    // ACCESS_CONTROL_HOST_WITH_CREDENTIALS is an empty string = set crossorigin to be "anonymous"
    // ACCESS_CONTROL_HOST_WITH_CREDENTIALS is set to a host = set crossorigin to ACCESS_CONTROL_CROSS_ORIGIN if the location of
    // requested resources are the same as the access-controlled host, otherwise assume that the request is to a location
    // that accepts "anonymous"
    if (!url.startsWith(baseOrigin + '/')) {
      // maybe needs credentials
      const config = QlikSystem.config();
      if (config.ACCESS_CONTROL_HOST_WITH_CREDENTIALS) {
        script.crossOrigin = url.startsWith(config.ACCESS_CONTROL_HOST_WITH_CREDENTIALS) ? config.ACCESS_CONTROL_CROSS_ORIGIN : 'anonymous';
      } else {
        script.crossOrigin = "anonymous";
      }
    }
    script.src = url;
    return script;
  };
})(typeof self !== 'undefined' ? self : global);
